module.exports = __webpack_public_path__ + "static/media/exito.25c1a0a4.png";